<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title" v-if="inactivateUserDefaultAction == 'inactivate'">Inactivate User</h6>
        <h6 class="modal-title" v-if="inactivateUserDefaultAction == 'activate'">Activate User</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;">
              <b v-if="inactivateUserDefaultAction == 'inactivate'">Are you sure you want to inactivate {{ userName }}?</b>              
              <b v-if="inactivateUserDefaultAction == 'activate'">Are you sure you want to activate {{ userName }}?</b>              
            </div>
        </div>
        <div class="col-12 p-0" style="margin-top: 30px;">
          <div class="col-6 p-0 float-left" style="text-align: left;">
            <button type="submit" class="btn btn-sm closeBtn" @click="closeModal">Cancel</button>
          </div>
          <div class="col-6 p-0 float-left" style="text-align: right;">
            <button :disabled="disable_submit_btn" type="submit" class="btn btn-md ma-blue-btn" @click="onSubmit" v-if="(inactivateUserDefaultAction == 'inactivate')">Inactivate User</button>
            <button :disabled="disable_submit_btn" type="submit" class="btn btn-md ma-blue-btn" @click="onSubmit" v-if="inactivateUserDefaultAction == 'activate'">Activate User</button>
          </div>
        </div>
      </div>
     </div>

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isModalVisible',
    'userName',
    'userId',
    'user',
    'inactivateUserDefaultAction',
    ],
  data() {
    return {
      loading: false,
      disable_submit_btn: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    inActivatePrimaryUser() {
      this.disable_submit_btn = true;
      this.closeModal();
      this.$parent.openUpdatePrimaryManagerModal(this.user);
    },
    onSubmit() {
      this.disable_submit_btn = true;
        axios('/desktop/v2/inactivate-user',
        {
          method: 'POST',
          data: {
            user_id: this.userId,
            account_id: this.$store.state.user_accountid,
            action: this.inactivateUserDefaultAction,
          },
        })
        .then(() => {       
          this.disable_submit_btn = false;   
          let message = 'Inactivated ' + this.userName + ' successfully.';
          if (this.inactivateUserDefaultAction == 'activate') {
            message = 'Activated ' + this.userName + ' successfully.';
          }
          
          this.$emit('close');
          this.flash({ message: message, variant: 'success' });
          window.location.reload(); 
        })
        .catch((error) => {
          this.disable_submit_btn = false;   
        });
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  width: 150px;
}
.closeBtn {
  width: 150px;
}
.ma-white-btn {
  width: 110px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/inactive_user_modal.vue